import { ScreenerResultsFAQSection } from 'domains/signup/screener/Components/ScreenerResultsSummary/Sections/FAQ';
import { ScreenerResultsIntroSection } from 'domains/signup/screener/Components/ScreenerResultsSummary/Sections/Intro';
import { ScreenerResultsNextStepsSection } from 'domains/signup/screener/Components/ScreenerResultsSummary/Sections/NextSteps';
import { ScreenerResultsPDFSection } from 'domains/signup/screener/Components/ScreenerResultsSummary/Sections/PDFDownload';
import { ScreenerResultsQuestionsSection } from 'domains/signup/screener/Components/ScreenerResultsSummary/Sections/QuestionResults';
import { ScreenerResultsScheduleSection } from 'domains/signup/screener/Components/ScreenerResultsSummary/Sections/Schedule';

const ScreenerResultSections = {
  Intro: ScreenerResultsIntroSection,
  Schedule: ScreenerResultsScheduleSection,
  Questions: ScreenerResultsQuestionsSection,
  NextSteps: ScreenerResultsNextStepsSection,
  FAQ: ScreenerResultsFAQSection,
  PDF: ScreenerResultsPDFSection,
};

export default ScreenerResultSections;
